import { authFetch } from "./authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

const toYmd = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (!(value instanceof Date)) return "";
  const y = value.getFullYear();
  const m = String(value.getMonth() + 1).padStart(2, "0");
  const d = String(value.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export async function getAdminLogs({
  keyword = "",
  searchField = "all",
  actionFilter = "all",
  startDate = null,
  endDate = null,
  cursorCreatedAt = null,
  cursorId = null,
  limit = 30,
} = {}) {
  try {
    const qs = new URLSearchParams();
    qs.set("searchField", searchField || "all");
    qs.set("actionFilter", actionFilter || "all");
    qs.set("limit", String(Math.max(10, Number(limit) || 30)));

    const safeKeyword = String(keyword ?? "").trim();
    if (safeKeyword) qs.set("keyword", safeKeyword);

    const startYmd = toYmd(startDate);
    const endYmd = toYmd(endDate);
    if (startYmd) qs.set("startDate", startYmd);
    if (endYmd) qs.set("endDate", endYmd);

    if (cursorCreatedAt) qs.set("cursorCreatedAt", String(cursorCreatedAt));
    if (cursorId) qs.set("cursorId", String(cursorId));

    const path = `${BACKEND_URL}/admin/get_logs?${qs.toString()}`;

    const res = await authFetch(
      path,
      { method: "GET" },
      { refreshUrlIncludes: "auth/refresh" },
    );

    let result = null;
    try {
      result = await res.json();
    } catch {
      result = null;
    }

    if (!res.ok || result?.success !== true) {
      return {
        success: false,
        message: result?.message || "로그 목록 조회 실패",
        rows: [],
        totalCount: 0,
        hasMore: false,
        nextCursor: null,
      };
    }

    const data = result?.data ?? {};
    return {
      success: true,
      message: result?.message || "로그 목록을 불러왔습니다.",
      rows: Array.isArray(data?.rows) ? data.rows : [],
      totalCount: Number(data?.totalCount ?? 0),
      hasMore: Boolean(data?.hasMore),
      nextCursor: data?.nextCursor ?? null,
      limit: Number(data?.limit ?? limit),
    };
  } catch (error) {
    return {
      success: false,
      message: error?.message || "네트워크 오류가 발생했습니다.",
      rows: [],
      totalCount: 0,
      hasMore: false,
      nextCursor: null,
    };
  }
}
